// extracted by mini-css-extract-plugin
module.exports = {"select":"Select_select__F5LE9"};